export default "__VITE_ASSET__0bLhIfNt__"